import React, { useEffect, useState } from "react";
import "./GenericTabs.css";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { Nav } from "react-bootstrap";

const GenericTabs = ({ tabs }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const parentTabFromUrl = searchParams.get("tab")
  const subTabFromUrl = searchParams.get("subTab");
  const [activeTabIndex, setActiveTabIndex] = useState(
    tabs.findIndex(tab => tab.tabId === subTabFromUrl) || 0
  );

  useEffect(() => {
    const index = tabs.findIndex(tab => tab.tabId === subTabFromUrl);
    if (index !== -1 && index !== activeTabIndex) {
      setActiveTabIndex(index);
    }
  }, [subTabFromUrl, tabs]);

  const handleTabClick = (tabId, index) => {
    setSearchParams({ tab: parentTabFromUrl, subTab: tabId });
    setActiveTabIndex(index);
  };

  return (
    <div className="generic-tabs-parent">
      <div className="generic-tabs-inner-container">
        <div className="generic-tabs-container">
          {tabs.map((tab, index) => (
            <Nav.Link
              key={tab.tabId}
              as="span"
              onClick={() => handleTabClick(tab.tabId, index)}
              className={`generic-tab-item ${
                activeTabIndex === index ? "generic-tab-active" : ""
              }`}
            >
              {tab.label}
            </Nav.Link>
          ))}
        </div>

        <div className="generic-tab-content">{tabs[activeTabIndex]?.comp}</div>
      </div>
    </div>
  );
};

export default GenericTabs;
